import END_POINT from 'src/config/endpoints.constants';
import { ApiResponse, ApiResult, getErrorMessage } from '../lib/API';
import { MakeCallDetail, UUID } from '../types';
import axios from 'axios';
export interface MakeCallResult extends ApiResult {
    data?: {
        callDetail: MakeCallDetail;
    };
}

export interface MakeCallResponse extends ApiResponse {
    data: MakeCallDetail;
}

export interface MakeCallOptions {
    fromNumber: string;
    toNumber: string | null;
    specialityTags: string;
    deviceId: UUID;
}

export default async function makeCall(options: MakeCallOptions, config: any = {}) {
    const result: MakeCallResult = {};
    try {
        const { data: responseData } = await axios.post<MakeCallResponse>(
            END_POINT.MAKE_CALL,
            options,
            config,
        );
        if (responseData) {
            if (responseData.code === 0) {
                result.data = {
                    callDetail: responseData.data,
                };
            } else {
                if (responseData && responseData?.data) {
                    result.data = {
                        callDetail: responseData?.data,
                    };
                }
                result.error = responseData.message;
            }
        }
    } catch (error) {
        result.error = getErrorMessage(error);
    }
    return result;
}
